import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import * as api from './api'
import type { AvailabilityStatus } from './types'

export const availabilityKeys = {
  mine: ['availability', 'me'] as const,
}

export function useMyAvailability() {
  return useQuery({
    queryKey: availabilityKeys.mine,
    queryFn: api.getMyAvailability,
    staleTime: 60_000,
  })
}

export function useSetMyAvailability() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: { teamId: number; status: AvailabilityStatus }) =>
      api.setMyAvailability(vars.teamId, vars.status),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: availabilityKeys.mine })
    },
  })
}
